import { useContext } from 'react'
import { DebuggerContext } from '../providers'

export const useDebugger = () => {
  return useContext(DebuggerContext)
}
